import axios from 'axios';

export default {
  activate() {
    return axios.post(`/api/email-verification/activate`)
      .then(response => response.data);
  },
  getInfo() {
    return axios.get(`/api/email-verification/info`)
      .then(response => response.data)
  },
  getCreditOptions() {
    return axios.get(`/api/email-verification-credits/options`)
      .then(response => response.data)
  },
  didLastMessageBounce(email) { // MLD-6336
    const config = {
      params: {
        email,
      }
    }
    return axios.get(`/api/email-verification/did-last-message-bounce`, config)
      .then(response => response.data.did_last_message_bounce)
  },
  verifyEmail(email) { // MLD-6544
    const form = {
      email,
    }
    return axios.post(`/api/email-verification/verify`, form)
      .then(response => response.data);
  },
  verify(form) { // MLD-6616
    return form.post(`/api/emails/verify`)
      .then(response => response.data);
  },
  override(form) {
    return form.post(`/api/email-verification/override`)
      .then(response => response.data);
  },
}
